import { render, staticRenderFns } from "./TurmasComIncidenciaPage.vue?vue&type=template&id=523c4676&scoped=true"
import script from "./TurmasComIncidenciaPage.vue?vue&type=script&lang=js"
export * from "./TurmasComIncidenciaPage.vue?vue&type=script&lang=js"
import style0 from "./TurmasComIncidenciaPage.vue?vue&type=style&index=0&id=523c4676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c4676",
  null
  
)

export default component.exports